import React from "react"

import ProjectSession from "../../../../model2/project/project-session"
import ProjectIconUI5 from "../../../icons/project/project-icon-ui5"

type Props = {
    project         : ProjectSession

    isHighlighted   : boolean

    onClickProject? : func
}

export default class FinderProject extends React.Component<Props> {

    click = () => {
        return this.onClickProject()
    }

    onClickProject = (e?: any) => {
        e && e.stopPropagation()
        if (this.props.onClickProject) {
            return this.props.onClickProject(this.props.project.id)
        }
    }

    render() {
        const classes = Classes("search-item project flex-row-left-center", {
            'is-highlighted': this.props.isHighlighted
        })

        return (
            <div className  = {classes}
                 onClick    = {this.onClickProject}
            >
                <ProjectIconUI5
                    className   = "search-item-icon project-icon"
                    project     = {this.props.project}
                    hint        = {false}
                    colorize    = {false}
                />
                <div className="search-item-title flex-1">{this.props.project.name}</div>
                <div className="search-item-arrow i5-big-angle-right"/>
            </div>
        )
    }
}
